import { Accordion } from '@/components/generals/accordion'
import { Reveal } from '@/components/generals/reveal'
import { SectionHeading } from '@/components/generals/section-heading'
import { TextLink } from '@/components/generals/text-link'
import { HOME_FAQS } from '@/constants/faq'

export const HomeFaq = () => {
    return (
        <section id='faq' aria-label='Frequently asked questions' className='relative py-24 sm:py-32'>
            <div aria-hidden='true' className='pointer-events-none absolute inset-x-0 top-1/3 h-[420px] bg-[radial-gradient(40%_55%_at_50%_50%,rgba(143,174,98,0.12),transparent_70%)]' />

            <div className='shell relative'>
                <SectionHeading
                    eyebrow='Questions'
                    title={'Before you sign up,\n*a few answers*'}
                    subtitle='What people usually want to know before linking their first account.'
                />

                <Reveal delay={200} className='mx-auto mt-14 max-w-2xl'>
                    <Accordion items={HOME_FAQS} variant='pills' defaultOpen={null} />
                </Reveal>

                <Reveal as='p' delay={300} className='mt-10 text-center text-sm text-cream/55'>
                    Something we missed?{' '}
                    <TextLink href='/contact'>
                        Talk to our team
                    </TextLink>
                </Reveal>
            </div>
        </section>
    )
}
